import React from 'react';
export function FinalCTA() {
  return <section className="w-full bg-cream py-20 px-4 flex flex-col items-center text-center border-t border-peach" data-id="element-32">
      <div className="max-w-3xl w-full" data-id="element-33">
        <h2 className="text-4xl md:text-5xl font-extrabold text-brown-800 mb-6 leading-tight" data-id="element-34">
          FREEZER INTELIGENTE
        </h2>

        <p className="text-xl md:text-2xl text-brown-800 font-bold mb-10" data-id="element-35">
          El próximo domingo podés seguir improvisando… o podés tener tu semana
          resuelta.
        </p>

        <div className="bg-red-100 text-red-600 font-bold py-2 px-6 rounded-full inline-block mb-8" data-id="element-36">
          ⏳ ÚLTIMAS HORAS DE PRECIO LANZAMIENTO
        </div>

        <div className="flex flex-col gap-4 max-w-md mx-auto mb-10" data-id="element-37">
          <a href="https://checkout.impulsodigitalx.shop/cart/45858009350305:1" className="w-full bg-white border-2 border-gold-400 text-brown-800 font-bold text-lg py-4 px-8 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 flex flex-col md:flex-row items-center justify-between" data-id="element-38">
            <span data-id="element-39">PLAN BÁSICO — $19.990</span>
            <span className="text-gold-500" data-id="element-40">👉 ACCEDER AHORA</span>
          </a>

          <a href="https://checkout.impulsodigitalx.shop/cart/45858012266657:1" className="w-full bg-gradient-to-r from-gold-400 to-gold-500 text-white font-bold text-lg py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 flex flex-col md:flex-row items-center justify-between" data-id="element-41">
            <span data-id="element-42">PLAN COMPLETO — $29.990</span>
            <span data-id="element-43">👉 ACCEDER AHORA</span>
          </a>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-brown-600 font-bold text-sm uppercase tracking-wide" data-id="element-44">
          <span className="flex items-center gap-1" data-id="element-45">🔥 ACCESO INMEDIATO</span>
          <span className="flex items-center gap-1" data-id="element-46">🛡️ GARANTÍA 7 DÍAS</span>
          <span className="flex items-center gap-1" data-id="element-47">
            💛 SISTEMA SIMPLE Y REAL
          </span>
        </div>
      </div>
    </section>;
}